<app-layout>
  <div class="main">
    <div class="header-table">
      <app-titulo>Relatórios</app-titulo>
      <div class="header-buttons">
        <app-botao type="secundario" class="button" text="Exportar Excel" icon="assets/exportar-excel.svg"
          (click)="exportarExcel()"></app-botao>
        <app-botao type="secundario" class="button" text="Exportar PDF" icon="assets/download.svg"
          (click)="exportarPDF()"></app-botao>
      </div>
    </div>

    <div class="desktop grid-outline">
      <div class="grid-header">
        <div class="intern-title">Financeiro</div>
        <div class="align-button">
          <form [formGroup]="form" class="table-filters">
            <app-input label="Nº do Serviço" placeholder="Digite aqui" name="PK_LAUD_SRVC" formControlName="PK_LAUD_SRVC"
              width="100%"></app-input>
            <app-input label="Placa" mask="AAA-0A00" placeholder="Digite aqui" name="TX_PLCA_CAVA"
              formControlName="TX_PLCA_CAVA" width="100%"></app-input>
            <app-input label="Empresa" placeholder="Digite aqui" name="NM_TRND" formControlName="NM_TRND"
              width="100%"></app-input>
            <app-input type="number" label="Valor" placeholder="Digite aqui" name="VL_SRVC" formControlName="VL_SRVC"
              width="100%"></app-input>
            <app-input type="select" label="Serviço" placeholder="Selecione" name="FK_SRVC"
              formControlName="FK_SRVC" [selectData]="servicoOptions" width="100%"></app-input>
            <app-input type="select" label="Caixa" placeholder="Selecione" name="FK_CAIX"
              formControlName="FK_CAIX" [selectData]="caixaOptions" [coerceValue]="'number'"
              [preserveOrder]="true" width="100%"></app-input>
            <app-input type="dropdown" label="Forma de Pagamento" placeholder="Selecione" coerceValue="number"
              name="NU_TIPO_PGMT" formControlName="NU_TIPO_PGMT" [selectData]="formasPagamento" width="100%"></app-input>
            <app-input type="datetime-local" label="Data Início Serviço" placeholder="Digite aqui" name="DT_INIC"
              formControlName="DT_INIC" width="100%"></app-input>
            <app-input type="datetime-local" label="Data Final Serviço" placeholder="Digite aqui" name="DT_FIM"
              formControlName="DT_FIM" width="100%"></app-input>
          </form>
        </div>
      </div>

      <app-loader [isLoading]="isLoading"></app-loader>

      <div class="table-scroll" *ngIf="!isLoading">
        <app-tabela [data]="tableData" [columns]="tableColumns"></app-tabela>
      </div>

      <div *ngIf="!isLoading && tableData.length" class="rodape-tabela">
        <div></div>
        <h2 class="valor">
          Valor Total: {{ valorTotalFormatado }}
        </h2>
      </div>
    </div>
  </div>

  <div class="mobile">
    <form [formGroup]="form" class="table-filters">
      <app-input label="Nº do Serviço" placeholder="Digite aqui" name="PK_LAUD_SRVC" formControlName="PK_LAUD_SRVC"
        width="100%"></app-input>
      <app-input label="Placa" mask="AAA-0A00" placeholder="Digite aqui" name="TX_PLCA_CAVA"
        formControlName="TX_PLCA_CAVA" width="100%"></app-input>
      <app-input label="Empresa" placeholder="Digite aqui" name="NM_TRND" formControlName="NM_TRND"
        width="100%"></app-input>
      <app-input type="number" label="Valor" placeholder="Digite aqui" name="VL_SRVC" formControlName="VL_SRVC"
        width="100%"></app-input>
      <app-input type="select" label="Serviço" placeholder="Selecione" name="FK_SRVC"
        formControlName="FK_SRVC" [selectData]="servicoOptions" width="100%"></app-input>
      <app-input type="select" label="Caixa" placeholder="Selecione" name="FK_CAIX"
        formControlName="FK_CAIX" [selectData]="caixaOptions" [coerceValue]="'number'"
        [preserveOrder]="true" width="100%"></app-input>
      <app-input type="dropdown" label="Forma de Pagamento" placeholder="Selecione" coerceValue="number"
        name="NU_TIPO_PGMT" formControlName="NU_TIPO_PGMT" [selectData]="formasPagamento" width="100%"></app-input>
      <app-input type="datetime-local" label="Data Início Serviço" placeholder="Digite aqui" name="DT_INIC"
        formControlName="DT_INIC" width="100%"></app-input>
      <app-input type="datetime-local" label="Data Final Serviço" placeholder="Digite aqui" name="DT_FIM"
        formControlName="DT_FIM" width="100%"></app-input>
    </form>

    <app-card *ngIf="!isLoading" [data]="tableData" [rows]="tableColumns" [expand]="true"></app-card>

    <div *ngIf="!isLoading && tableData.length" class="rodape-tabela">
      <h2 class="valor">
        Valor Total: {{ valorTotalFormatado }}
      </h2>
    </div>
  </div>

  <app-subtitulo *ngIf="!tableData.length">Nenhum registro encontrado.</app-subtitulo>

  <div class="paginacao">
    <app-paginacao *ngIf="tableData.length" [pages]="maxPages" (selectedPage)="mudarPagina($event)"></app-paginacao>
  </div>

  <app-loader [isLoading]="isLoading"></app-loader>
</app-layout>
